export const getLoadingData = (state) => state.LoadingData.Data;